import { api } from "./authService";

export interface MasterDepartmentItem {
  id: string;
  name: string;
  short_name?: string;
  code: string;
  institution_type?: string;
  institution_type_name?: string;
  institution_type_code?: string;
  university?: string;
  university_name?: string;
  university_code?: string;
  parent_department?: string;
  parent_department_name?: string;
  department_type: "academic" | "administrative" | "research" | "support" | "training";
  description?: string;
  hod?: string;
  hod_name?: string;
  hod_email?: string;
  contact_email?: string;
  contact_phone?: string;
  is_active: boolean;
  display_order: number;
  created_at?: string;
  updated_at?: string;
}

export const departmentMasterService = {
  getDepartments: async (params?: {
    search?: string;
    is_active?: boolean;
    institution_type?: string;
    university?: string;
    department_type?: string;
  }): Promise<{ results: MasterDepartmentItem[] } | MasterDepartmentItem[]> => {
    const response = await api.get("/master/departments/", { params });
    return response.data;
  },

  createDepartment: async (data: {
    name: string;
    short_name?: string;
    code: string;
    institution_type?: string;
    university?: string;
    parent_department?: string;
    department_type?: string;
    description?: string;
    hod?: string;
    contact_email?: string;
    contact_phone?: string;
    is_active?: boolean;
    display_order?: number;
  }): Promise<MasterDepartmentItem> => {
    const response = await api.post("/master/departments/", data);
    return response.data;
  },

  updateDepartment: async (
    id: string,
    data: Partial<{
      name: string;
      short_name: string;
      code: string;
      institution_type: string;
      university: string;
      parent_department: string;
      department_type: string;
      description: string;
      hod: string;
      contact_email: string;
      contact_phone: string;
      is_active: boolean;
      display_order: number;
    }>
  ): Promise<MasterDepartmentItem> => {
    const response = await api.patch(`/master/departments/${id}/`, data);
    return response.data;
  },

  deleteDepartment: async (id: string): Promise<void> => {
    await api.delete(`/master/departments/${id}/`);
  },
};
